// src/components/trades/components/TabButton.js
//
// Extracted from inline definition in TradeCenter.js per Tier 2 #7
// commit 7a (refactor only — no behavior change).
import React from 'react';
import { dynastyTheme } from '../../../services/colorService';

const TabButton = ({ active, onClick, label, count, highlight, icon }) => (
  <button
    onClick={onClick}
    className={`px-4 py-2 font-medium ${dynastyTheme.classes.transition} ${
      active
        ? `${dynastyTheme.classes.text.primary} border-b-2 ${dynastyTheme.classes.border.primary}`
        : dynastyTheme.classes.text.neutralLight
    }`}
  >
    <div className="flex items-center gap-2">
      {icon}
      {label}
      {count !== undefined && count > 0 && (
        <span className={`
          ml-1 px-2 py-0.5 rounded-full text-xs font-bold
          ${highlight
            ? 'bg-yellow-500/20 text-yellow-300 border border-yellow-500/40'
            : active
              ? dynastyTheme.components.badge.primary
              : dynastyTheme.components.badge.secondary
          }
        `}>
          {count}
        </span>
      )}
    </div>
  </button>
);

export default TabButton;
